import React from 'react';
import { ReactComponent as CheckboxUnCheckedIcon } from '../checkbox.svg';
import { ReactComponent as CheckboxCheckedIcon } from '../checkbox-checked.svg';

interface IProps extends React.SVGProps<SVGSVGElement> {
    checked: boolean;
    dataQa?: string;
}

export const CheckboxIcon: React.FC<IProps> = ({ dataQa, ...props }) =>
    props.checked ? (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <CheckboxCheckedIcon {...props} data-qa={dataQa} />
    ) : (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <CheckboxUnCheckedIcon {...props} data-qa={dataQa} />
    );
